// Linuxコマンドのオプション情報
export const linuxCommandOptions = {
  ls: {
    defaultBehavior: "カレントディレクトリのファイルとディレクトリを名前順に簡易表示。隠しファイルは表示されず、詳細情報も出ない。",
    options: [
      { flag: "-l", origin: "long format（長形式）", role: "詳細情報を縦に表示。権限、所有者、サイズ、日時が見える。" },
      { flag: "-a", origin: "all（すべて）", role: "隠しファイル（.で始まる）も表示。設定ファイル確認に必須。" },
      { flag: "-h", origin: "human-readable（人間が読める）", role: "ファイルサイズをKB、MB単位で表示。-lと併用が定番。" },
      { flag: "-t", origin: "time（時刻）", role: "更新日時順にソート。最新ファイルが上に来る。" },
      { flag: "-R", origin: "recursive（再帰的）", role: "サブディレクトリも全て表示。ディレクトリ構造の把握に。" }
    ],
    combos: [
      { pattern: "ls -lah", desc: "詳細+隠しファイル+人間可読サイズ。運用現場の鉄板コマンド。" },
      { pattern: "ls -lt | head", desc: "最新更新ファイルを上位表示。ログ調査で頻出。" },
      { pattern: "ls -lR", desc: "配下のディレクトリ構造を全て詳細表示。構成確認に便利。" }
    ]
  },

  mkdir: {
    defaultBehavior: "指定した名前のディレクトリを作成。",
    options: [
      { flag: "-p", origin: "parents（親）", role: "親ディレクトリも同時に作成。エラーを出さず、必要な階層を全て作る。" },
      { flag: "-m", origin: "mode（モード）", role: "作成時にパーミッションを指定。セキュアなディレクトリ作成に。" }
    ],
    combos: [
      { pattern: "mkdir -p project/src/components", desc: "深い階層を一発作成。開発環境構築の定番。" },
      { pattern: "mkdir -m 700 private", desc: "所有者のみアクセス可能なディレクトリを作成。" }
    ]
  },

  cd: {
    defaultBehavior: "ホームディレクトリに移動する。ホームディレクトリとは、各ユーザー専用のフォルダのこと。",
    options: [
      { flag: "-", origin: "dash（前のディレクトリ）", role: "直前のディレクトリに戻る（cd -）。" },
      { flag: "-P", origin: "physical（物理）", role: "シンボリックリンクを解決して物理パスへ移動（bashなど）。" },
      { flag: "-L", origin: "logical（論理）", role: "論理的パスを優先（デフォルト）。" }
    ],
    combos: [
      { pattern: "cd /var/log", desc: "絶対パスへ移動。ログディレクトリに入る。" },
      { pattern: "cd ..", desc: "親ディレクトリに移動。" },
      { pattern: "cd -", desc: "直前のディレクトリに戻る。作業の往復に便利。" },
      { pattern: "cd", desc: "引数なしでホームディレクトリに移動。" }
    ]
  },

  pwd: {
    defaultBehavior: "現在のカレントディレクトリ（作業中のフォルダ）の絶対パスを表示する。絶対パスとは、ルート（最上位）からファイルやフォルダへの「完全な住所」で、「国→都道府県→市→町→番地」のようなイメージ。",
    options: [
      { flag: "-L", origin: "logical（論理）", role: "論理的なパス（シェルの環境変数PWD）を表示。シンボリックリンクをそのまま表示する場合がある。" },
      { flag: "-P", origin: "physical（物理）", role: "シンボリックリンクを解決して実際の物理パスを表示する。" },
      { flag: "--help", origin: "help（ヘルプ）", role: "利用可能なオプションを表示する（実装による）。" }
    ],
    combos: [
      { pattern: "pwd", desc: "現在の作業ディレクトリの絶対パスを表示する。" },
      { pattern: "pwd -P", desc: "シンボリックリンクを解決した物理パスを表示する。" },
      { pattern: "pwd -L", desc: "論理パス（シェルが保持するPWD）を表示する。" }
    ]
  },

  rm: {
    defaultBehavior: "指定したファイルを削除する。オプションなしだとディレクトリは削除できない。これは、誤操作による事故防止の仕様。",
    options: [
      { flag: "-i", origin: "interactive（対話的）", role: "削除前に確認。誤削除防止に効果的。" },
      { flag: "-r", origin: "recursive（再帰的）", role: "ディレクトリを再帰削除。フォルダごと消す時に必須。" },
      { flag: "-f", origin: "force（強制）", role: "確認なし強制削除。スクリプトで使用。慎重に。" }
    ],
    combos: [
      { pattern: "rm -rf directory/", desc: "ディレクトリを強制的に完全削除。破壊力最大。要注意。" },
      { pattern: "rm -i *.log", desc: "ログファイルを確認しながら削除。安全運用の基本。" }
    ]
  },

  cp: {
    defaultBehavior: "ファイルを指定先にコピー。",
    options: [
      { flag: "-r", origin: "recursive（再帰的）", role: "ディレクトリをコピー。中身も全て複製。" },
      { flag: "-i", origin: "interactive（対話的）", role: "上書き前に確認。既存ファイル保護に。" },
      { flag: "-p", origin: "preserve（保存）", role: "タイムスタンプと権限を保持してコピー。バックアップに最適。" },
      { flag: "-a", origin: "archive（アーカイブ）", role: "-rpd相当。全属性保持で完全バックアップ。" }
    ],
    combos: [
      { pattern: "cp -r src/ dest/", desc: "ディレクトリを丸ごとコピー。" },
      { pattern: "cp -a backup/ /mnt/external/", desc: "完全バックアップ作成。アーカイブモードで全属性保持。" }
    ]
  },

  mv: {
    defaultBehavior: "ファイルやディレクトリを移動または名前変更。上書き確認なしで実行される。",
    options: [
      { flag: "-i", origin: "interactive（対話的）", role: "上書き前に確認。重要ファイル保護。" },
      { flag: "-n", origin: "no-clobber（上書きしない）", role: "既存ファイルがあれば移動しない。安全重視。" },
      { flag: "-v", origin: "verbose（詳細）", role: "移動内容を表示。スクリプトのデバッグに。" }
    ],
    combos: [
      { pattern: "mv -i oldname newname", desc: "ファイル名変更。上書き確認付き。" },
      { pattern: "mv *.txt documents/", desc: "複数ファイルを一括移動。整理作業の定番。" }
    ]
  },

  grep: {
    defaultBehavior: "指定したパターンに一致する行を標準入力またはファイルから検索して表示。大文字小文字を区別する。",
    options: [
      { flag: "-r", origin: "recursive（再帰的）", role: "ディレクトリ配下を再帰検索。プロジェクト全体から文字列検索。" },
      { flag: "-i", origin: "ignore-case（大文字小文字無視）", role: "大文字小文字を区別せず検索。柔軟な検索に。" },
      { flag: "-n", origin: "line-number（行番号）", role: "マッチした行番号も表示。コード特定に便利。" },
      { flag: "-v", origin: "invert-match（反転マッチ）", role: "マッチしない行を表示。除外検索に。" },
      { flag: "-E", origin: "extended-regexp（拡張正規表現）", role: "拡張正規表現を使用。複雑なパターン検索に。" }
    ],
    combos: [
      { pattern: "grep -rn 'error' /var/log/", desc: "ログから行番号付きでエラー検索。障害調査の定番。" },
      { pattern: "ps aux | grep nginx", desc: "プロセス一覧から特定プロセスを抽出。運用の基本コマンド。" },
      { pattern: "grep -v '^#' config.txt", desc: "コメント行を除外して設定ファイル表示。" }
    ]
  },

  find: {
    options: [
      { flag: "-name", origin: "name（名前）", role: "ファイル名で検索。ワイルドカード使用可。" },
      { flag: "-type", origin: "type（種類）", role: "ファイルタイプで絞り込み。f=ファイル、d=ディレクトリ。" },
      { flag: "-mtime", origin: "modification time（更新時刻）", role: "更新日時で検索。日数指定可能。" },
      { flag: "-size", origin: "size（サイズ）", role: "ファイルサイズで検索。大容量ファイル発見に。" },
      { flag: "-exec", origin: "execute（実行）", role: "見つかったファイルに対してコマンド実行。" }
    ],
    combos: [
      { pattern: "find . -name '*.log' -mtime +7 -delete", desc: "7日以上前のログファイルを削除。自動クリーンアップ。" },
      { pattern: "find /var -type f -size +100M", desc: "100MB超のファイルを検索。ディスク容量調査に。" },
      { pattern: "find . -name '*.js' -exec grep 'TODO' {} \\;", desc: "JSファイルからTODOを検索。コードレビューに。" }
    ]
  },

  cat: {
    defaultBehavior: "ファイルの内容を標準出力に表示。複数ファイル指定時は連結して表示。",
    options: [
      { flag: "-n", origin: "number（番号）", role: "行番号を表示。コード確認に便利。" },
      { flag: "-A", origin: "show-all（すべて表示）", role: "非表示文字も可視化。改行やタブの確認に。" },
      { flag: "-s", origin: "squeeze-blank（空行圧縮）", role: "連続する空行を1行にまとめる。見やすさ向上。" }
    ],
    combos: [
      { pattern: "cat -n script.sh", desc: "行番号付きでファイル表示。デバッグに便利。" },
      { pattern: "cat file1 file2 > merged.txt", desc: "複数ファイルを結合。ログマージの定番。" }
    ]
  },

  tar: {
    defaultBehavior: "アーカイブファイルを作成または展開。-c（作成）か-x（展開）のどちらかは必須。",
    options: [
      { flag: "-c", origin: "create（作成）", role: "アーカイブを作成。圧縮の第一歩。" },
      { flag: "-x", origin: "extract（展開）", role: "アーカイブを展開。解凍時に使用。" },
      { flag: "-v", origin: "verbose（詳細）", role: "処理内容を表示。進捗確認に。" },
      { flag: "-f", origin: "file（ファイル）", role: "アーカイブファイル名を指定。必須オプション。" },
      { flag: "-z", origin: "gzip", role: "gzip圧縮を使用。.tar.gz作成に。" },
      { flag: "-j", origin: "bzip2", role: "bzip2圧縮を使用。高圧縮率。" }
    ],
    combos: [
      { pattern: "tar -czvf archive.tar.gz directory/", desc: "ディレクトリをgzip圧縮。バックアップの定番。" },
      { pattern: "tar -xzvf archive.tar.gz", desc: "gzip圧縮を展開。解凍の基本コマンド。" },
      { pattern: "tar -cjvf archive.tar.bz2 directory/", desc: "bzip2で高圧縮。容量重視のバックアップ。" }
    ]
  },

  chmod: {
    defaultBehavior: "ファイルやディレクトリのパーミッション（権限）を変更。数値または記号で指定。",
    options: [
      { flag: "-R", origin: "recursive（再帰的）", role: "ディレクトリ配下全てに適用。一括権限変更。" },
      { flag: "-v", origin: "verbose（詳細）", role: "変更内容を表示。権限変更の確認に。" }
    ],
    combos: [
      { pattern: "chmod 755 script.sh", desc: "実行権限付与。スクリプト実行の基本。" },
      { pattern: "chmod -R 700 private/", desc: "所有者のみアクセス可能に。セキュリティ強化。" },
      { pattern: "chmod +x deploy.sh", desc: "実行ビットを追加。シンプルな権限付与。" }
    ]
  },

  ssh: {
    defaultBehavior: "指定したホストにSSH接続。デフォルトポート22番、パスワード認証または公開鍵認証。",
    options: [
      { flag: "-p", origin: "port（ポート）", role: "接続ポートを指定。デフォルトは22番。" },
      { flag: "-i", origin: "identity（身元）", role: "秘密鍵ファイルを指定。公開鍵認証に。" },
      { flag: "-v", origin: "verbose（詳細）", role: "詳細ログ表示。接続トラブル時のデバッグに。" },
      { flag: "-L", origin: "local（ローカル）", role: "ローカルポートフォワーディング。トンネリングに。" }
    ],
    combos: [
      { pattern: "ssh -i ~/.ssh/id_rsa user@host", desc: "公開鍵認証でSSH接続。セキュアな接続方法。" },
      { pattern: "ssh -p 2222 user@host", desc: "非標準ポートで接続。セキュリティ対策済みサーバーへ。" },
      { pattern: "ssh -L 8080:localhost:80 user@host", desc: "ローカルの8080番をリモートの80番に転送。" }
    ]
  },

  ps: {
    defaultBehavior: "現在のシェルで実行中のプロセスのみ表示。他ユーザーや全プロセスは表示されない。",
    options: [
      { flag: "aux", origin: "all users + user-oriented + x", role: "全ユーザーの全プロセスを詳細表示。BSD形式。" },
      { flag: "-ef", origin: "every + full format", role: "全プロセスをフルフォーマット表示。System V形式。" }
    ],
    combos: [
      { pattern: "ps aux | grep nginx", desc: "特定プロセスを検索。運用現場の定番。" },
      { pattern: "ps aux --sort=-%mem | head", desc: "メモリ使用量順に表示。リソース調査に。" }
    ]
  },

  kill: {
    defaultBehavior: "指定したプロセスIDにSIGTERM（シグナル15）を送信して正常終了を要求。",
    options: [
      { flag: "-9", origin: "SIGKILL（シグナル9）", role: "強制終了。プロセスを即座に停止。最終手段。" },
      { flag: "-15", origin: "SIGTERM（シグナル15）", role: "正常終了要求。デフォルトシグナル。穏やかな終了。" },
      { flag: "-HUP", origin: "SIGHUP（ハングアップ）", role: "設定再読込。デーモンのリロードに使用。" }
    ],
    combos: [
      { pattern: "kill -9 1234", desc: "プロセスID 1234を強制終了。応答なしプロセスに。" },
      { pattern: "kill -HUP $(cat /var/run/nginx.pid)", desc: "nginxの設定をリロード。無停止で設定反映。" }
    ]
  },

  df: {
    defaultBehavior: "マウントされた全ファイルシステムのディスク使用状況を512バイトブロック単位で表示。",
    options: [
      { flag: "-h", origin: "human-readable（人間が読める）", role: "サイズをKB、MB、GB単位で表示。" },
      { flag: "-T", origin: "type（タイプ）", role: "ファイルシステムタイプも表示。" },
      { flag: "-i", origin: "inodes", role: "iノード使用状況を表示。小ファイル多数時に重要。" }
    ],
    combos: [
      { pattern: "df -h", desc: "ディスク使用率を人間可読形式で表示。容量確認の定番。" },
      { pattern: "df -hT | grep ext4", desc: "ext4ファイルシステムのみ表示。特定FS調査。" }
    ]
  },

  du: {
    defaultBehavior: "カレントディレクトリとサブディレクトリのディスク使用量を512バイトブロック単位で表示。",
    options: [
      { flag: "-h", origin: "human-readable（人間が読める）", role: "サイズを読みやすく表示。" },
      { flag: "-s", origin: "summarize（要約）", role: "合計のみ表示。ディレクトリサイズ確認に。" },
      { flag: "-c", origin: "total（合計）", role: "総計を表示。複数ディレクトリの合計算出。" },
      { flag: "--max-depth", origin: "maximum depth（最大深度）", role: "表示階層を制限。見やすさ向上。" }
    ],
    combos: [
      { pattern: "du -sh directory/", desc: "ディレクトリサイズを一行で表示。容量調査の鉄板。" },
      { pattern: "du -h --max-depth=1 | sort -h", desc: "1階層のみサイズ順表示。容量犯人特定に。" }
    ]
  },

  touch: {
    defaultBehavior: "ファイルが存在しない場合は空ファイルを作成、存在する場合はタイムスタンプを現在時刻に更新。",
    options: [
      { flag: "-t", origin: "time（時刻）", role: "タイムスタンプを指定。日時の偽装に使用。" },
      { flag: "-r", origin: "reference（参照）", role: "他ファイルのタイムスタンプをコピー。" }
    ],
    combos: [
      { pattern: "touch newfile.txt", desc: "空ファイル作成。開発で頻繁に使用。" },
      { pattern: "touch -t 202301010000 file.txt", desc: "タイムスタンプを2023年1月1日に設定。" }
    ]
  },

  less: {
    defaultBehavior: "ファイルの内容をページ単位で表示。上下スクロール、検索が可能。catより大きなファイルに適している。",
    options: [
      { flag: "-N", origin: "line Numbers（行番号）", role: "行番号を表示。コード確認に。" },
      { flag: "-S", origin: "chop long lines（長行切断）", role: "行の折り返しをしない。横スクロール可能に。" },
      { flag: "+F", origin: "Follow（追従）", role: "tail -f相当。ログをリアルタイム表示。" }
    ],
    combos: [
      { pattern: "less -N /var/log/syslog", desc: "行番号付きでログ表示。調査に便利。" },
      { pattern: "less +F /var/log/application.log", desc: "ログをリアルタイム追跡。tail -fの代替。" }
    ]
  },

  head: {
    defaultBehavior: "ファイルの先頭10行を表示。複数ファイル指定時は各ファイルの先頭を表示。",
    options: [
      { flag: "-n", origin: "number（数）", role: "表示行数を指定。デフォルトは10行。" },
      { flag: "-c", origin: "bytes（バイト数）", role: "先頭からバイト数で表示。" }
    ],
    combos: [
      { pattern: "head -n 20 log.txt", desc: "先頭20行を表示。ログの初動確認に。" },
      { pattern: "ps aux | head", desc: "プロセス一覧の上位を表示。" }
    ]
  },

  tail: {
    defaultBehavior: "ファイルの末尾10行を表示。最新のログ確認に便利。",
    options: [
      { flag: "-n", origin: "number（数）", role: "表示行数を指定。デフォルトは10行。" },
      { flag: "-f", origin: "follow（追従）", role: "ファイルをリアルタイム監視。ログ監視の定番。" },
      { flag: "-F", origin: "Follow retry（追従リトライ）", role: "ファイル再作成にも追従。ログローテート対応。" }
    ],
    combos: [
      { pattern: "tail -f /var/log/syslog", desc: "システムログをリアルタイム監視。運用の基本。" },
      { pattern: "tail -n 100 error.log", desc: "直近100行のエラーログを表示。障害調査に。" },
      { pattern: "tail -F app.log", desc: "ログローテート後も追従。長時間監視に。" }
    ]
  },

  sudo: {
    defaultBehavior: "root権限で指定コマンドを実行。パスワード認証が必要。sudoers設定に従う。",
    options: [
      { flag: "-u", origin: "user（ユーザー）", role: "実行ユーザーを指定。デフォルトはroot。" },
      { flag: "-i", origin: "interactive login（対話ログイン）", role: "ログインシェルを起動。環境変数も引き継ぐ。" },
      { flag: "-s", origin: "shell（シェル）", role: "シェルを起動。rootシェル取得に使用。" }
    ],
    combos: [
      { pattern: "sudo apt update", desc: "root権限でパッケージ更新。システム管理の基本。" },
      { pattern: "sudo -u www-data ls /var/www", desc: "www-dataユーザーとして実行。権限テストに。" },
      { pattern: "sudo -i", desc: "rootのログインシェルに切り替え。完全なroot環境。" }
    ]
  },

  scp: {
    defaultBehavior: "SSH経由でファイルをコピー。リモート⇔ローカル間の安全な転送。",
    options: [
      { flag: "-r", origin: "recursive（再帰的）", role: "ディレクトリを再帰コピー。" },
      { flag: "-P", origin: "port（ポート）", role: "SSH接続ポートを指定。大文字Pに注意。" },
      { flag: "-i", origin: "identity（身元）", role: "秘密鍵ファイルを指定。" },
      { flag: "-p", origin: "preserve（保存）", role: "タイムスタンプと権限を保持。" }
    ],
    combos: [
      { pattern: "scp -r local_dir/ user@host:/remote/path/", desc: "ディレクトリをリモートに転送。デプロイの基本。" },
      { pattern: "scp -P 2222 file.txt user@host:~/", desc: "非標準ポートでファイル転送。" }
    ]
  },

  wget: {
    defaultBehavior: "URLからファイルをダウンロード。元のファイル名で保存。HTTP/HTTPS/FTP対応。",
    options: [
      { flag: "-O", origin: "output（出力）", role: "保存ファイル名を指定。別名保存に。" },
      { flag: "-c", origin: "continue（継続）", role: "中断したダウンロードを再開。大容量ファイルに。" },
      { flag: "-r", origin: "recursive（再帰的）", role: "Webサイトを再帰的にダウンロード。ミラーリング。" },
      { flag: "-q", origin: "quiet（静か）", role: "進捗を表示しない。スクリプト内で使用。" }
    ],
    combos: [
      { pattern: "wget -c https://example.com/large.zip", desc: "中断可能なダウンロード。途中から再開可能。" },
      { pattern: "wget -O latest.tar.gz https://example.com/v1.2.tar.gz", desc: "別名で保存。バージョン管理に。" }
    ]
  },

  zip: {
    defaultBehavior: "指定したファイルをzip形式で圧縮。ディレクトリは再帰オプション必須。",
    options: [
      { flag: "-r", origin: "recursive（再帰的）", role: "ディレクトリを再帰的に圧縮。" },
      { flag: "-e", origin: "encrypt（暗号化）", role: "パスワード暗号化。セキュアな圧縮。" },
      { flag: "-q", origin: "quiet（静か）", role: "進捗を表示しない。" }
    ],
    combos: [
      { pattern: "zip -r archive.zip directory/", desc: "ディレクトリをzip圧縮。Windows互換性重視。" },
      { pattern: "zip -e secure.zip sensitive.doc", desc: "パスワード付きで圧縮。機密ファイルの送付に。" }
    ]
  },

  unzip: {
    defaultBehavior: "zipファイルをカレントディレクトリに展開。上書き確認あり。",
    options: [
      { flag: "-d", origin: "directory（ディレクトリ）", role: "展開先ディレクトリを指定。" },
      { flag: "-l", origin: "list（一覧）", role: "中身を展開せず一覧表示。内容確認に。" },
      { flag: "-q", origin: "quiet（静か）", role: "メッセージを表示しない。" }
    ],
    combos: [
      { pattern: "unzip archive.zip", desc: "カレントディレクトリに展開。基本操作。" },
      { pattern: "unzip -l archive.zip", desc: "中身を確認。展開前の内容チェック。" },
      { pattern: "unzip archive.zip -d target/", desc: "指定ディレクトリに展開。整理しながら解凍。" }
    ]
  },

  echo: {
    defaultBehavior: "引数の文字列を標準出力に表示。末尾に改行を追加。",
    options: [
      { flag: "-n", origin: "no newline（改行なし）", role: "末尾の改行を出力しない。" },
      { flag: "-e", origin: "enable interpretation（解釈有効）", role: "エスケープシーケンスを解釈。\\nなど有効に。" }
    ],
    combos: [
      { pattern: "echo 'export PATH=$PATH:/usr/local/bin' >> ~/.bashrc", desc: "設定ファイルに追記。環境構築の定番。" },
      { pattern: "echo -e 'Line1\\nLine2'", desc: "改行を含む文字列を出力。メッセージ表示に。" }
    ]
  },

  date: {
    defaultBehavior: "現在の日時を標準書式で表示。曜日と時刻も含む。",
    options: [
      { flag: "+%Y-%m-%d", origin: "format（書式）", role: "日付書式を指定。ISO 8601形式など。" },
      { flag: "-d", origin: "date（日付）", role: "指定日時を表示。相対指定も可能。" }
    ],
    combos: [
      { pattern: "date +%Y%m%d", desc: "20230615形式で日付取得。ファイル名に使用。" },
      { pattern: "date -d '3 days ago' +%Y-%m-%d", desc: "3日前の日付を取得。ログ調査に。" }
    ]
  },

  uname: {
    defaultBehavior: "オペレーティングシステムの名前（Linuxなど）を表示。",
    options: [
      { flag: "-a", origin: "all（すべて）", role: "システム情報を全て表示。" },
      { flag: "-r", origin: "kernel release（カーネルリリース）", role: "カーネルバージョンを表示。" },
      { flag: "-m", origin: "machine（マシン）", role: "ハードウェアアーキテクチャを表示。x86_64など。" }
    ],
    combos: [
      { pattern: "uname -a", desc: "システム情報を一括表示。環境確認の基本。" },
      { pattern: "uname -r", desc: "カーネルバージョン確認。ドライバ互換性調査に。" }
    ]
  },

  top: {
    defaultBehavior: "リアルタイムでプロセスをCPU使用率順に表示。動的に更新される対話型モニター。",
    options: [
      { flag: "-u", origin: "user（ユーザー）", role: "特定ユーザーのプロセスのみ表示。" },
      { flag: "-d", origin: "delay（遅延）", role: "更新間隔を秒単位で指定。" },
      { flag: "-n", origin: "number（数）", role: "更新回数を指定。指定回数後に終了。" }
    ],
    combos: [
      { pattern: "top -u username", desc: "特定ユーザーのプロセス監視。リソース調査に。" },
      { pattern: "top -d 5", desc: "5秒間隔で更新。ゆっくり監視。" }
    ]
  },

  crontab: {
    defaultBehavior: "現在ユーザーのcron設定を表示または編集するエディタを起動。",
    options: [
      { flag: "-e", origin: "edit（編集）", role: "cronジョブを編集。定期実行設定。" },
      { flag: "-l", origin: "list（一覧）", role: "登録済みcronジョブを一覧表示。" },
      { flag: "-r", origin: "remove（削除）", role: "全cronジョブを削除。注意して使用。" }
    ],
    combos: [
      { pattern: "crontab -e", desc: "cronジョブを編集。定期バックアップ設定などに。" },
      { pattern: "crontab -l", desc: "設定済みジョブ確認。スケジュール確認に。" }
    ]
  },

  ping: {
    defaultBehavior: "指定ホストにICMPエコー要求を無限に送信し続ける。Ctrl+Cで停止。",
    options: [
      { flag: "-c", origin: "count（カウント）", role: "送信回数を指定。デフォルトは無限。" },
      { flag: "-i", origin: "interval（間隔）", role: "送信間隔を秒単位で指定。" },
      { flag: "-W", origin: "timeout（タイムアウト）", role: "応答待機時間を指定。" }
    ],
    combos: [
      { pattern: "ping -c 4 google.com", desc: "4回だけpingを送信。基本的な疎通確認。" },
      { pattern: "ping -i 0.2 -c 10 192.168.1.1", desc: "0.2秒間隔で10回送信。高速疎通テスト。" }
    ]
  },

  curl: {
    defaultBehavior: "指定URLにGETリクエストを送信し、レスポンス本文を標準出力に表示。",
    options: [
      { flag: "-X", origin: "request method", role: "HTTPメソッドを指定。POST、PUT、DELETEなど。" },
      { flag: "-H", origin: "header（ヘッダー）", role: "HTTPヘッダーを指定。認証トークンなど。" },
      { flag: "-d", origin: "data（データ）", role: "POSTデータを指定。APIリクエストに。" },
      { flag: "-o", origin: "output（出力）", role: "レスポンスをファイルに保存。" },
      { flag: "-I", origin: "head（ヘッド）", role: "ヘッダーのみ取得。ステータス確認に。" }
    ],
    combos: [
      { pattern: "curl -X POST -H 'Content-Type: application/json' -d '{\"key\":\"value\"}' https://api.example.com", desc: "JSON POSTリクエスト。API操作の定番。" },
      { pattern: "curl -I https://example.com", desc: "HTTPヘッダーのみ取得。ステータスコード確認。" }
    ]
  },

  netstat: {
    defaultBehavior: "アクティブなインターネット接続とUnixドメインソケットを表示。",
    options: [
      { flag: "-a", origin: "all（すべて）", role: "全ての接続とリスニングポートを表示。" },
      { flag: "-n", origin: "numeric（数値）", role: "アドレスを数値で表示。名前解決しない。" },
      { flag: "-t", origin: "tcp", role: "TCP接続のみ表示。" },
      { flag: "-u", origin: "udp", role: "UDP接続のみ表示。" },
      { flag: "-p", origin: "program（プログラム）", role: "プログラム名とPIDを表示。" }
    ],
    combos: [
      { pattern: "netstat -antp", desc: "TCP接続を数値表示＋プロセス情報。ポート調査の定番。" },
      { pattern: "netstat -tuln", desc: "リスニングポートを一覧表示。サービス確認に。" }
    ]
  },

  rsync: {
    defaultBehavior: "ファイルとディレクトリをローカルまたはリモートにコピー。差分転送で高速化。",
    options: [
      { flag: "-a", origin: "archive（アーカイブ）", role: "アーカイブモード。権限やタイムスタンプ保持。" },
      { flag: "-v", origin: "verbose（詳細）", role: "詳細表示。転送内容確認に。" },
      { flag: "-z", origin: "compress（圧縮）", role: "転送データを圧縮。ネットワーク帯域節約。" },
      { flag: "--delete", origin: "delete（削除）", role: "転送元にないファイルを転送先から削除。完全同期。" }
    ],
    combos: [
      { pattern: "rsync -avz source/ dest/", desc: "ディレクトリ同期。差分転送で高速バックアップ。" },
      { pattern: "rsync -avz --delete src/ user@host:/backup/", desc: "完全同期バックアップ。リモートに差分転送。" }
    ]
  },

  diff: {
    defaultBehavior: "2つのファイルを行単位で比較し、差分をコンテキスト形式で表示。",
    options: [
      { flag: "-u", origin: "unified（統合）", role: "unified形式で差分表示。Gitスタイル。" },
      { flag: "-r", origin: "recursive（再帰的）", role: "ディレクトリを再帰的に比較。" },
      { flag: "-q", origin: "brief（簡潔）", role: "差分があるかどうかのみ表示。" }
    ],
    combos: [
      { pattern: "diff -u old.txt new.txt", desc: "ファイル差分をunified形式で表示。パッチ作成に。" },
      { pattern: "diff -r dir1/ dir2/", desc: "ディレクトリの差分比較。構成確認に。" }
    ]
  },

  ln: {
    defaultBehavior: "ハードリンクを作成。同じiノードを指す別名ファイル。",
    options: [
      { flag: "-s", origin: "symbolic（シンボリック）", role: "シンボリックリンクを作成。ショートカット相当。" },
      { flag: "-f", origin: "force（強制）", role: "既存リンクを上書き。" }
    ],
    combos: [
      { pattern: "ln -s /path/to/original /path/to/link", desc: "シンボリックリンク作成。ファイルショートカットに。" },
      { pattern: "ln -sf new_target existing_link", desc: "既存リンクを新ターゲットに変更。" }
    ]
  },

  sort: {
    defaultBehavior: "テキストの行を辞書順（アルファベット順）にソートして表示。",
    options: [
      { flag: "-n", origin: "numeric（数値）", role: "数値としてソート。文字列ソートと異なる。" },
      { flag: "-r", origin: "reverse（逆順）", role: "降順でソート。" },
      { flag: "-k", origin: "key（キー）", role: "ソートキー列を指定。" },
      { flag: "-u", origin: "unique（ユニーク）", role: "重複行を削除。" }
    ],
    combos: [
      { pattern: "sort -n numbers.txt", desc: "数値ソート。ログのカウント結果整理に。" },
      { pattern: "du -sh * | sort -h", desc: "ディレクトリをサイズ順ソート。容量調査に。" }
    ]
  },

  wc: {
    defaultBehavior: "ファイルの行数、単語数、バイト数を表示。3つの数値を出力。",
    options: [
      { flag: "-l", origin: "lines（行）", role: "行数をカウント。ログ行数確認に。" },
      { flag: "-w", origin: "words（単語）", role: "単語数をカウント。" },
      { flag: "-c", origin: "bytes（バイト）", role: "バイト数をカウント。ファイルサイズ確認。" }
    ],
    combos: [
      { pattern: "wc -l file.txt", desc: "ファイル行数を表示。ログサイズ確認に。" },
      { pattern: "ps aux | wc -l", desc: "プロセス数をカウント。システム負荷把握に。" }
    ]
  },

  cut: {
    defaultBehavior: "各行からタブ区切りのフィールドを抽出。デフォルトは全フィールド。",
    options: [
      { flag: "-d", origin: "delimiter（区切り文字）", role: "区切り文字を指定。デフォルトはタブ。" },
      { flag: "-f", origin: "fields（フィールド）", role: "抽出するフィールド番号を指定。" },
      { flag: "-c", origin: "characters（文字）", role: "文字位置で抽出。" }
    ],
    combos: [
      { pattern: "cut -d':' -f1 /etc/passwd", desc: "ユーザー名のみ抽出。CSV的なデータ処理に。" },
      { pattern: "ps aux | cut -c1-50", desc: "プロセス情報を50文字で切断。表示幅調整に。" }
    ]
  },

  sed: {
    defaultBehavior: "標準入力またはファイルのテキストを編集し、結果を標準出力に表示。ファイルは変更しない。",
    options: [
      { flag: "-i", origin: "in-place（その場で）", role: "ファイルを直接編集。バックアップなし。" },
      { flag: "-e", origin: "expression（式）", role: "編集コマンドを指定。複数指定可能。" },
      { flag: "-n", origin: "quiet（静か）", role: "自動出力を抑制。pコマンドと併用。" }
    ],
    combos: [
      { pattern: "sed 's/old/new/g' file.txt", desc: "文字列置換。設定ファイル一括変更に。" },
      { pattern: "sed -i 's/foo/bar/g' *.conf", desc: "ファイル内を直接置換。複数ファイル一括編集。" }
    ]
  },

  awk: {
    defaultBehavior: "標準入力を行ごとに処理し、空白区切りのフィールドを$1, $2...として扱う。全行を出力。",
    options: [
      { flag: "-F", origin: "field separator（フィールド区切り）", role: "入力フィールド区切り文字を指定。" }
    ],
    combos: [
      { pattern: "awk '{print $1}' file.txt", desc: "1列目のみ抽出。ログ解析の基本。" },
      { pattern: "ps aux | awk '{sum+=$3} END {print sum}'", desc: "CPU使用率の合計を計算。リソース集計に。" }
    ]
  },

  xargs: {
    defaultBehavior: "標準入力から受け取った行を引数としてコマンドを実行。デフォルトはechoコマンド。",
    options: [
      { flag: "-I", origin: "replace string（置換文字列）", role: "置換文字列を指定。複雑なコマンド構築に。" },
      { flag: "-n", origin: "max-args（最大引数）", role: "1回のコマンド実行で渡す引数数を指定。" },
      { flag: "-P", origin: "max-procs（最大プロセス）", role: "並列実行数を指定。高速処理。" }
    ],
    combos: [
      { pattern: "find . -name '*.txt' | xargs grep 'error'", desc: "複数ファイルから文字列検索。一括grep。" },
      { pattern: "ls *.jpg | xargs -I {} convert {} {}.png", desc: "全JPGをPNGに変換。並列画像処理。" }
    ]
  },

  watch: {
    defaultBehavior: "指定コマンドを2秒間隔で繰り返し実行し、結果を画面にクリア表示。",
    options: [
      { flag: "-n", origin: "interval（間隔）", role: "実行間隔を秒単位で指定。デフォルトは2秒。" },
      { flag: "-d", origin: "differences（差分）", role: "前回との差分をハイライト表示。変化を視覚化。" }
    ],
    combos: [
      { pattern: "watch -n 1 df -h", desc: "1秒ごとにディスク容量表示。リアルタイム監視。" },
      { pattern: "watch -d 'ps aux | grep nginx'", desc: "nginxプロセスを監視。変化をハイライト。" }
    ]
  },

  lsof: {
    defaultBehavior: "現在開かれている全ファイルとネットワーク接続を一覧表示。",
    options: [
      { flag: "-i", origin: "internet（インターネット）", role: "ネットワーク接続を表示。ポート番号指定可能。" },
      { flag: "-u", origin: "user（ユーザー）", role: "特定ユーザーが開いているファイルを表示。" },
      { flag: "-p", origin: "process（プロセス）", role: "特定プロセスが開いているファイルを表示。" }
    ],
    combos: [
      { pattern: "lsof -i :80", desc: "80番ポートを使用しているプロセスを表示。ポート調査に。" },
      { pattern: "lsof -u username", desc: "特定ユーザーの開いているファイル一覧。リソース調査。" }
    ]
  },

  tcpdump: {
    defaultBehavior: "デフォルトネットワークインターフェースの全パケットをキャプチャして画面表示。",
    options: [
      { flag: "-i", origin: "interface（インターフェース）", role: "キャプチャするネットワークインターフェースを指定。" },
      { flag: "-n", origin: "numeric（数値）", role: "ホスト名を解決しない。高速表示。" },
      { flag: "-w", origin: "write（書込）", role: "パケットをファイルに保存。後で解析。" },
      { flag: "-r", origin: "read（読込）", role: "保存したパケットファイルを読込。" }
    ],
    combos: [
      { pattern: "tcpdump -i eth0 port 80", desc: "80番ポートのパケットキャプチャ。HTTP通信解析。" },
      { pattern: "tcpdump -n -w capture.pcap", desc: "パケットをファイル保存。詳細解析用。" }
    ]
  },

  dig: {
    defaultBehavior: "指定ドメインのA（IPv4アドレス）レコードを詳細情報付きで照会。",
    options: [
      { flag: "+short", origin: "short（短縮）", role: "簡潔な出力。IPアドレスのみ表示。" },
      { flag: "@server", origin: "at server（サーバー指定）", role: "問い合わせDNSサーバーを指定。" }
    ],
    combos: [
      { pattern: "dig +short google.com", desc: "IPアドレスのみ簡潔に表示。DNS確認の基本。" },
      { pattern: "dig @8.8.8.8 example.com", desc: "GoogleのDNSで名前解決。代替DNS確認に。" }
    ]
  },

  chown: {
    defaultBehavior: "指定ファイル/ディレクトリの所有者を変更。グループも同時指定可能。",
    options: [
      { flag: "-R", origin: "recursive（再帰的）", role: "ディレクトリ配下全てに適用。一括所有者変更。" },
      { flag: "-v", origin: "verbose（詳細）", role: "変更内容を表示。" }
    ],
    combos: [
      { pattern: "chown user:group file.txt", desc: "ファイルの所有者とグループを変更。" },
      { pattern: "chown -R www-data:www-data /var/www/", desc: "Webディレクトリの所有者を一括変更。" }
    ]
  },

  chgrp: {
    defaultBehavior: "指定ファイル/ディレクトリのグループ所有権を変更。",
    options: [
      { flag: "-R", origin: "recursive（再帰的）", role: "ディレクトリ配下全てに適用。" },
      { flag: "-v", origin: "verbose（詳細）", role: "変更内容を表示。" }
    ],
    combos: [
      { pattern: "chgrp developers project/", desc: "プロジェクトディレクトリのグループ変更。" },
      { pattern: "chgrp -R staff /shared/", desc: "共有ディレクトリのグループ一括変更。" }
    ]
  },

  systemctl: {
    defaultBehavior: "systemdの状態を一覧表示。ユニット（サービス）のステータス確認。",
    options: [
      { flag: "start", origin: "start（開始）", role: "サービスを開始。" },
      { flag: "stop", origin: "stop（停止）", role: "サービスを停止。" },
      { flag: "restart", origin: "restart（再起動）", role: "サービスを再起動。設定反映に。" },
      { flag: "enable", origin: "enable（有効化）", role: "システム起動時に自動起動を有効化。" },
      { flag: "status", origin: "status（状態）", role: "サービスの状態を表示。" }
    ],
    combos: [
      { pattern: "systemctl restart nginx", desc: "nginxを再起動。設定変更後の定番操作。" },
      { pattern: "systemctl enable docker", desc: "Docker自動起動を有効化。起動時設定。" },
      { pattern: "systemctl status sshd", desc: "SSH状態確認。サービス稼働チェック。" }
    ]
  },

  journalctl: {
    defaultBehavior: "systemdジャーナルの全ログをページャーで表示。古い順に表示。",
    options: [
      { flag: "-u", origin: "unit（ユニット）", role: "特定サービスのログを表示。" },
      { flag: "-f", origin: "follow（追従）", role: "ログをリアルタイム表示。tail -f相当。" },
      { flag: "--since", origin: "since（から）", role: "指定時刻以降のログを表示。" },
      { flag: "-n", origin: "lines（行数）", role: "表示行数を指定。" }
    ],
    combos: [
      { pattern: "journalctl -u nginx -f", desc: "nginxログをリアルタイム監視。systemd環境の定番。" },
      { pattern: "journalctl --since '1 hour ago'", desc: "直近1時間のログを表示。障害調査に。" }
    ]
  },

  apt: {
    defaultBehavior: "APTパッケージマネージャーのヘルプを表示。サブコマンド必須。",
    options: [
      { flag: "update", origin: "update（更新）", role: "パッケージリストを更新。インストール前の必須操作。" },
      { flag: "upgrade", origin: "upgrade（アップグレード）", role: "インストール済みパッケージを更新。" },
      { flag: "install", origin: "install（インストール）", role: "新規パッケージをインストール。" },
      { flag: "remove", origin: "remove（削除）", role: "パッケージを削除。設定ファイルは残す。" },
      { flag: "autoremove", origin: "auto remove（自動削除）", role: "不要な依存パッケージを削除。クリーンアップ。" }
    ],
    combos: [
      { pattern: "apt update && apt upgrade -y", desc: "システム全体を最新化。定期メンテナンスの定番。" },
      { pattern: "apt install -y nginx", desc: "確認なしでnginxインストール。自動化スクリプトに。" }
    ]
  },

  dnf: {
    defaultBehavior: "DNFパッケージマネージャー。サブコマンドで検索/導入/更新/削除を行う（Fedora/RHEL系）。",
    options: [
      { flag: "install", origin: "install（導入）", role: "パッケージをインストール。" },
      { flag: "update", origin: "update（更新）", role: "インストール済みパッケージを更新。" },
      { flag: "remove", origin: "remove（削除）", role: "パッケージを削除。" },
      { flag: "search", origin: "search（検索）", role: "名前/説明でパッケージ検索。" },
      { flag: "info", origin: "info（情報）", role: "パッケージの詳細情報を表示。" }
    ],
    combos: [
      { pattern: "dnf search nginx", desc: "nginxを検索。" },
      { pattern: "dnf install -y nginx", desc: "nginxを確認なしで導入。" },
      { pattern: "dnf update -y", desc: "パッケージを一括更新。" }
    ]
  },

  ufw: {
    defaultBehavior: "UFW（Uncomplicated Firewall）。FWを簡単に有効化し、許可/拒否ルールを管理する。",
    options: [
      { flag: "status", origin: "status（状態）", role: "現在のルールと有効/無効を表示。" },
      { flag: "enable", origin: "enable（有効化）", role: "ファイアウォールを有効にする。" },
      { flag: "disable", origin: "disable（無効化）", role: "ファイアウォールを無効にする。" },
      { flag: "allow", origin: "allow（許可）", role: "ポート/サービスを許可。" },
      { flag: "deny", origin: "deny（拒否）", role: "ポート/サービスを拒否。" }
    ],
    combos: [
      { pattern: "ufw status verbose", desc: "詳細な状態を確認。" },
      { pattern: "ufw allow 22/tcp", desc: "SSH（22/tcp）を許可。" },
      { pattern: "ufw allow 80,443/tcp", desc: "Web（80/443）を許可。" },
      { pattern: "ufw enable", desc: "ルールを有効化（順序に注意）。" }
    ]
  },

  gzip: {
    defaultBehavior: "指定ファイルをgzip形式で圧縮し、元ファイルは削除される。.gz拡張子が付く。",
    options: [
      { flag: "-d", origin: "decompress（展開）", role: "圧縮を解凍。gunzip相当。" },
      { flag: "-k", origin: "keep（保持）", role: "元ファイルを削除せず保持。" },
      { flag: "-9", origin: "best compression（最高圧縮）", role: "最高圧縮率で圧縮。時間かかるが小さくなる。" }
    ],
    combos: [
      { pattern: "gzip -k file.txt", desc: "元ファイルを残して圧縮。バックアップ保持。" },
      { pattern: "gzip -d file.gz", desc: "gzipファイルを解凍。" }
    ]
  }
};

export const getLinuxOptions = (commandName) => {
  return linuxCommandOptions[commandName] || null;
};
